
export const OPTION_FIELD_TYPES = ["radio", "checkbox", "dropdownsingle", "dropdownmulti"];

export function fieldHasOptions(fieldType) {
    return OPTION_FIELD_TYPES.includes(fieldType);
}

function dependenciesAreSatisfied(prereqOptionIds, activeOptionIds) {
    return !prereqOptionIds?.length || prereqOptionIds.every(id => activeOptionIds.has(id));
}

export function buildDependencyState(sections) {
    const activeOptionIds = new Set();
    const activeSectionIds = new Set();
    const activeFieldIds = new Set();

    for (const section of sections || []) {
        if (!dependenciesAreSatisfied(section.prereqOptionIds, activeOptionIds)) continue;

        activeSectionIds.add(section.id);

        for (const field of section.fields || []) {
            if (!dependenciesAreSatisfied(field.prereqOptionIds, activeOptionIds)) continue;

            activeFieldIds.add(field.id);
            if (fieldHasOptions(field.type)) {
                field.options.filter(o => o.selected).forEach(o => activeOptionIds.add(o.id));
            }
        }
    }

    return { activeOptionIds, activeSectionIds, activeFieldIds };
}
